<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Really want to remove?</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-layout align-center justify-space-between row>
          <v-btn outlined text @click="cancel">Cancel</v-btn>
          <v-btn color="error" @click="remove">
            Delete
          </v-btn>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AppLayoutsDelete',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    remove() {
      this.$store
        .dispatch('app_layout/remove', {
          app_layout: this.id
        })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('success', data);
        });
    }
  }
};
</script>
